export const rightSidebarCollapse: React.FC = (props) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_424_6387)">
      <mask id="mask0_424_6387" maskUnits="userSpaceOnUse" x="0" y="0"
        width="20" height="21">
        <path d="M20 20.8347L0 20.8347L0 0.44599L20 0.44599L20 20.8347Z" fill="white" />
      </mask>
      <g mask="url(#mask0_424_6387)">
        <path
          d="M14.0113 2.3575L14.0113 18.9233M3.195 2.3575L16.805 2.3575C17.3212 2.3575 17.8163 2.55119 18.18 2.89652C18.3581 3.06168 18.5007 3.26267 18.5988 3.48682C18.6969 3.71097 18.7484 3.95341 18.75 4.19885L18.75 17.082C18.75 18.0989 17.88 18.9233 16.805 18.9233L3.195 18.9233C2.12 18.9233 1.25 18.0989 1.25 17.082L1.25 4.19885C1.25 3.18197 2.12125 2.3575 3.195 2.3575Z"
          stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M9.97872 11.1272C10.0252 11.0798 10.0621 11.0236 10.0873 10.9617C10.1124 10.8998 10.1254 10.8335 10.1254 10.7665C10.1254 10.6995 10.1124 10.6332 10.0873 10.5713C10.0621 10.5095 10.0252 10.4532 9.97872 10.4059L6.97872 7.3476C6.9088 7.27623 6.81967 7.22762 6.72263 7.20792C6.62558 7.18822 6.52499 7.19831 6.43358 7.23693C6.34217 7.27554 6.26405 7.34093 6.20911 7.42483C6.15418 7.50873 6.12489 7.60735 6.12497 7.70822L6.12497 13.8248C6.12489 13.9257 6.15418 14.0243 6.20911 14.1082C6.26405 14.1921 6.34217 14.2575 6.43358 14.2961C6.52499 14.3348 6.62558 14.3448 6.72263 14.3251C6.81967 14.3054 6.9088 14.2568 6.97872 14.1855L9.97872 11.1272Z"
          fill="currentColor" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_424_6387">
        <rect width="20" height="20.3887" fill="white" transform="matrix(-1 0 0 -1 20 20.8347)" />
      </clipPath>
    </defs>
  </svg>
)